import type React from 'react';

export type PaginationMode = 'client' | 'server';

export interface UsePaginationDataParams<T> {
  mode?: PaginationMode;
  data?: T[];
  totalItems?: number;
  onServerRequest?: (page: number, rowsPerPage: number) => void;
  initialRowsPerPage?: number;
  initialPage?: number;
}

export interface PaginationControlsProps {
  mode?: PaginationMode;
  totalItems: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  rowsPerPage: number;
  setRowsPerPage?: (rows: number) => void;
  onRowsPerPageChange?: (rows: number) => void;
  rowsPerPageOptions?: number[];
  siblingCount?: number;
  isLoading?: boolean;
  className?: string;
}

export interface PaginationData<T> {
  mode: string;
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  rowsPerPage: number;
  setRowsPerPage: React.Dispatch<React.SetStateAction<number>>;
  currentData: T[];
  totalItems: number;
}
